<template>
  <div class="plan-item-3">
    <div class="title">计划辅助营养师/专家</div>
    <div class="expert-container">
      <div
        class="expert-type-item"
        v-if="
          data.expert_list.primary_experts &&
          data.expert_list.primary_experts.list.length
        "
      >
        <div class="expert-type-item-title">主营养师</div>
        <div class="expert-type-item-desc"
          >职责：{{ data.expert_list.primary_experts.duty }}</div
        >
        <div class="expert-list">
          <div
            class="expert-item"
            @click="bindToCoachDetail(item)"
            v-for="(item, index) in data.expert_list.primary_experts.list"
            :key="index"
          >
            <img class="e-item-avatar" :src="item.head_portrait" />
            <div class="e-item-right">
              <div class="e-item-name">{{ item.name }}</div>
              <div class="e-item-desc"
                ><span v-for="(item1, index1) in item.title" :key="index1">{{
                  item1 + ' '
                }}</span></div
              >
            </div>
          </div>
        </div>
      </div>
      <div
        class="expert-type-item"
        v-if="
          data.expert_list.assistant_experts &&
          data.expert_list.assistant_experts.list.length
        "
      >
        <div class="expert-type-item-title">助教营养师</div>
        <div class="expert-type-item-desc"
          >职责：{{ data.expert_list.assistant_experts.duty }}</div
        >
        <div class="expert-list" v-if="data.expert_list.assistant_experts.list">
          <div
            class="expert-item row-type2"
            @click="bindClick(item)"
            v-for="(item, index) in data.expert_list.assistant_experts.list"
            :key="index"
          >
            <img class="e-item-avatar" :src="item.head_portrait" />
            <div class="e-item-right">
              <div class="e-item-name">{{ item.name }}</div>
              <div class="e-item-desc"
                ><span v-for="(item1, index1) in item.title" :key="index1">{{
                  item1 + ' '
                }}</span></div
              >
            </div>
          </div>
        </div>
      </div>
      <div
        class="expert-type-item"
        v-if="
          data.expert_list.intervene_experts &&
          data.expert_list.intervene_experts.list.length
        "
      >
        <div class="expert-type-item-title">干预专家</div>
        <div class="expert-type-item-desc"
          >职责：{{ data.expert_list.intervene_experts.duty }}</div
        >
        <div class="expert-list">
          <div
            class="expert-item"
            @click="bindClick(item)"
            v-for="(item, index) in data.expert_list.intervene_experts.list"
            :key="index"
          >
            <img class="e-item-avatar" :src="item.head_portrait" />
            <div class="e-item-right">
              <div class="e-item-name">{{ item.name }}</div>
              <div class="e-item-desc"
                ><span v-for="(item1, index1) in item.title" :key="index1">{{
                  item1 + ' '
                }}</span></div
              >
            </div>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
export default {
  components: {},
  props: {
    data: {
      type: Object,
      default: null
    }
  },
  data() {
    return {}
  },
  created() {},
  methods: {
    bindClick(item) {
      if (this.$betterwe.isApp()) {
        this.$betterwe.jumpRoute(
          `/dietitianDetails?id=${item.dietitian_id}&isLogin=1`
        )
      } else {
        this.$router.push('/app-download')
      }
    },
    bindToCoachDetail(item) {
      if (this.$betterwe.isApp()) {
        this.$router.push({
          path: '/app-camp/nutritionist-detail',
          query: {
            id: item.expert_id
          }
        })
      } else {
        this.$router.push('/app-download')
      }
    }
  }
}
</script>
<style lang="scss" scoped>
.plan-item-3 {
  .title {
    position: relative;
    color: rgba(48, 48, 56, 0.7);
    padding-left: 10px;
    font-weight: bold;
    font-size: 16px;
    line-height: 22px;
    margin-bottom: 11px;
  }

  .title::after {
    content: '';
    position: absolute;
    left: 0;
    top: 50%;
    width: 4px;
    height: 20px;
    background-color: rgba(48, 48, 56, 0.3);
    transform: translate(0%, -50%);
  }

  .expert-container {
    padding: 14px;
    background: #ffffff;
    border-radius: 6px;

    .expert-type-item {
      margin-bottom: 16px;
      .expert-type-item-title {
        font-weight: bold;
        font-size: 14px;
        line-height: 20px;
        margin-bottom: 5px;
      }

      .expert-type-item-desc {
        font-size: 11px;
        color: rgba(48, 48, 56, 0.5);
        line-height: 16px;
        margin-bottom: 10px;
      }

      .expert-list {
        display: flex;
        flex-wrap: wrap;

        .expert-item {
          box-sizing: border-box;
          width: 100%;
          background: #f5f5f5;
          border-radius: 4px;
          padding: 10px;
          display: flex;
          align-items: center;
          margin-bottom: 10px;
          .e-item-avatar {
            width: 47px;
            height: 47px;
            border-radius: 50%;
            overflow: hidden;
            object-fit: cover;
            margin-right: 7px;
          }

          .e-item-right {
            flex: 1;
            flex-shrink: 0;
            overflow: hidden;
            .e-item-name {
              white-space: nowrap;
              text-overflow: ellipsis;
              overflow: hidden;
              font-weight: bold;
              font-size: 13px;
              color: rgba(48, 48, 56, 0.7);
              line-height: 18px;
              margin-bottom: 4px;
            }

            .e-item-desc {
              white-space: nowrap;
              text-overflow: ellipsis;
              overflow: hidden;
              font-size: 11px;
              color: rgba(48, 48, 56, 0.5);
              line-height: 16px;
            }
          }
        }
        .expert-item:last-child {
          margin-bottom: 0;
        }
        .row-type2 {
          width: 158px;
          margin-bottom: 10px;
          margin-right: 10px;
        }
        .row-type2:last-child {
          margin-right: 0;
          margin-bottom: 10px;
        }
      }
    }
  }
}
</style>
